import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import ReadMoreText from "./ReadMoreText";

import "swiper/css";
import "swiper/css/pagination";

function Products() {
  const [isSlider, setIsSlider] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSlider(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const productsData = [
    {
      num: "01",
      title: "Business Intelligence Database",
      desc: "India's most comprehensive B2B contact and company database — 10M+ verified business records across 500+ industries.",
      tags: ["Most Popular", "10M+ Records"],
      featured: true,
    },
    {
      num: "02",
      title: "Consumer Insights Data",
      desc: "Understand your customers with demographic & behavioral data.",
      tags: ["B2C", "Demographics"],
    },
    {
      num: "03",
      title: "Market Intelligence Reports",
      desc: "Industry deep-dives with trends & opportunity mapping.",
      tags: ["Reports", "Insights"],
    },
    {
      num: "04",
      title: "Location & Geo Data",
      desc: "Hyperlocal targeting & logistics optimization data.",
      tags: ["Geo", "Hyperlocal"],
    },
    {
      num: "05",
      title: "Custom Data Packages",
      desc: "Fully tailored datasets built specifically for your goals.",
      tags: ["Custom", "On-demand"],
    },
  ];

  return (
    <section id="products" className="products-section">
      <div className="container">

        {/* Header */}
        <div className="products-header">
          <span className="section-label">DATA PRODUCTS</span>
          <h2 className="section-title">Ready-to-Deploy Data Products</h2>
          <p className="section-sub">
            Pre-built, immediately usable datasets across India's most active sectors.
          </p>
        </div>

        {/* 🔁 CONDITION */}
        {isSlider ? (

          /* SLIDER (Mobile + Laptop) */
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
            }}
          >
            {productsData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className={`product-card ${item.featured ? "featured" : ""}`}>
                  <div className="product-num">{item.num}</div>
                  <div className="product-content">
                    <h3>{item.title}</h3>
                    <ReadMoreText text={item.desc} />
                    <div className="tags">
                      {item.tags.map((tag, i) => (
                        <span className="tag" key={i}>{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        ) : (

          /* GRID (Desktop Only) */
          <div className="products-grid">
            {productsData.map((item, index) => (
              <div
                key={index}
                className={`product-card ${item.featured ? "featured" : ""}`}
              >
                <div className="product-num">{item.num}</div>
                <div className="product-content">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                  <div className="tags">
                    {item.tags.map((tag, i) => (
                      <span className="tag" key={i}>{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

        )}

      </div>
    </section>
  );
}

export default Products;